import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateEndTimeSmartScheduleShift", function updateEndTimeSmartScheduleShift(newTime: Moment) {
    if (shiftEditorViewState().smartScheduleShift && newTime) {
        shiftEditorViewState().smartScheduleShift.endTime = newTime.clone();
    }
});